import { render } from "./user_shop.vue?vue&type=template&id=3b2c5885"
import script from "./user_shop.vue?vue&type=script&lang=js"
export * from "./user_shop.vue?vue&type=script&lang=js"

import "./user_shop.vue?vue&type=style&index=0&id=3b2c5885&lang=css"

import exportComponent from "D:\\SchoolManagement-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__